import React from 'react'
import dynamic from 'next/dynamic'
import { proximaFont } from '../fonts'
import { CFooter } from '../components/organisms/c-footer'
import { CHeader } from '../components/organisms/c-header'
import { AssetInterface } from '../graphql/global-fragments'

type Props = {
  children: React.ReactNode
  logoImage?: {
    clearLogo: Array<AssetInterface>
    darkLogo: Array<AssetInterface>
  }
  isStella?: boolean
  footerSocials?: { socialType: string; socialLink: string }[] | undefined
  copyrightYear: number
}

const DynamicPreviewToast = dynamic(() =>
  import(/* webpackChunkName: "DynamicPreviewToast" */ 'ui').then(
    (x) => x.CPreviewToast
  )
)

const DefaultLayout = ({
  children,
  logoImage,
  footerSocials,
  isStella,
  copyrightYear,
}: Props) => {
  const isPreviewToastEnabled = Boolean(
    process.env.NEXT_PUBLIC_PREVIEW_MESSAGE_ENABLED
  )

  return (
    <main className={proximaFont.variable}>
      <CHeader logoImage={logoImage} isStella={isStella} />
      {children}
      <CFooter footerSocials={footerSocials} copyrightYear={copyrightYear} />
      {isPreviewToastEnabled && <DynamicPreviewToast />}
    </main>
  )
}

export default DefaultLayout
